import React from "react";
import { useTranslation } from "react-i18next";
import RegistrationPage from "../auth/Registration";
import '../../styles/addUserModal.css';

function AddUserModal({ onClose, reloadUserList, selectedUser }) {
    const { t } = useTranslation();
    const isEdit = selectedUser && selectedUser.id;

    return (
        <div className="modal fade show d-block custom-modal" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="modal-form-header">
                            <h3 className="modal-form-title">
                                {isEdit ? t("button.updateUser") : t("button.registerUser")}
                            </h3>
                            <p className="modal-form-subtitle">
                                {isEdit ? t("button.updateUser") : t("button.registerUser")}
                            </p>
                        </div>
                        <RegistrationPage isModal onClose={onClose} reloadUserList={reloadUserList} selectedUser={selectedUser} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddUserModal;